import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { money, partCategoryLabel, partOriginLabel } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Wrench, ShieldCheck } from "lucide-react";

const STATUS_STYLE = {
  reserved: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  sold_out: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
};
const STATUS_LABEL = { reserved: "Reserved", sold_out: "Sold Out" };

// Public parts listing card. Mirrors the WatchCard/MerchCard visual language.
export default function PartCard({ part }) {
  const to = `/parts/${part.slug || part.id}`;
  const photo = (part.public_photos && part.public_photos[0]) || null;
  const img = photo ? fileUrl(photo.url || photo) : null;
  const showPrice = !part.price_on_request && part.price != null;

  return (
    <Link
      to={to}
      data-testid={`part-card-${part.id}`}
      className="group block bg-[var(--panel-2)] border border-[var(--border-2)] overflow-hidden transition-colors hover:border-[#c9a86a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c9a86a]"
    >
      <div className="relative aspect-square bg-[var(--bg)] overflow-hidden">
        {img ? (
          <img src={img} alt={part.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[var(--border-2)]"><Wrench size={44} /></div>
        )}
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge variant="outline" className="bg-black/40 backdrop-blur text-[#c9a86a] border-[#c9a86a]/40 text-[10px] uppercase tracking-wide">
            {partCategoryLabel(part.part_category)}
          </Badge>
        </div>
        {STATUS_LABEL[part.status] && (
          <div className="absolute top-3 right-3">
            <Badge variant="outline" className={`text-[10px] ${STATUS_STYLE[part.status] || ""}`}>{STATUS_LABEL[part.status]}</Badge>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-[var(--text)] font-medium leading-snug line-clamp-2 min-h-[2.6rem]">{part.title}</h3>
        <div className="mt-1 text-xs text-[var(--text-2)] flex items-center gap-1.5 flex-wrap">
          {part.brand && <span>{part.brand}</span>}
          {part.reference_number && <span>· ref {part.reference_number}</span>}
          {part.origin === "oem" && <span className="inline-flex items-center gap-1 text-[#c9a86a]"><ShieldCheck size={11} /> OEM</span>}
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-[#c9a86a] font-medium text-sm">{showPrice ? money(part.price) : "Price on Request"}</span>
          {part.condition && <span className="text-[11px] text-[var(--text-2)]">{part.condition}</span>}
        </div>
      </div>
    </Link>
  );
}
